import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import AdBanner from "../components/ad-banner";
import { Link } from "gatsby";

{
	/* <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<!-- Ad 2 -->
<ins class="adsbygoogle"
     style="display:inline-block;width:970px;height:90px"
     data-ad-client="ca-pub-4526018463078856"
     data-ad-slot="3117407107"></ins>
<script>
(adsbygoogle = window.adsbygoogle || []).push({});
</script> */
}

const DonationFooter = ({ad = true}) => {
	return (
		<Container>
			<footer>
				{(ad) ? 
				<AdBanner />
				:
				<div style={{marginTop: 100}}></div>
				}
				<Row>
					<Col style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center"
					}}>
				
						{/* <small style={{ fontWeight: "500", fontSize: 20, textAlign: 'center' }}>
							How To Build A SaaS side-hustle<br />👇 That Actually Makes Money 👇 
						</small>
						<div style={{ marginTop: 30 }} />
						<div>

							<div>
								<a className="gumroad-button" href="https://quinston.com/micro-saas-side-hustle" target="_blank"><Button variant="dark">View Product</Button></a>
							</div>

						</div> */}

						<div style={{marginBottom: '5rem'}}></div>

					</Col>
				</Row>
			</footer>
		</Container>
	);
};

export default DonationFooter;
